<template>
  <div>
    <div class="fidx">
      <div class="sldw" v-if="typeds == 'login'">
        <div style="width: 62%; display: inline-block">
          <div style="text-align: center">
            <p :class="signin ? 'pwxactive pwx' : 'pwx'" @click="mima()">
              密码登录
              <span v-if="signin" style="
                  width: 0.4063rem;
                  height: 0.0208rem;
                  background: #4ab83e;
                  border-radius: 0.0156rem;
                  display: block;
                  margin: 0 auto;
                "></span>
            </p>
            <p :class="!signin ? 'pwxactive pwx' : 'pwx'" @click="duanxin()" style="margin-left: 0.2083rem">
              短信登录
              <span v-if="!signin" style="
                  width: 0.4063rem;
                  height: 0.0208rem;
                  background: #4ab83e;
                  border-radius: 0.0156rem;
                  display: block;
                  margin: 0 auto;
                "></span>
            </p>
          </div>
          <div v-if="signin">
            <div class="nlf_lab" style="margin-bottom: 0.1042rem">
              <input v-model="form.userName" value class="nlf_inp" placeholder="手机号/用户名" />
            </div>
            <div v-if="!switchPassDisFlag" class="nlf_lab" style="margin-bottom: 0.0417rem">
              <input type="password" style="width: 86%" password v-model="form.password" v-on:keyup.enter="denglu"
                class="nlf_inp nlf_pwd" placeholder="密码" />
              <p @click="SwitchPassDis()" style="
                  display: inline-block;
                  width: 0.125rem;
                  height: 0.125rem;
                  cursor: pointer;
                ">
                <img src="../../static/images/bmm.png" alt="" />
              </p>
            </div>
            <div v-else class="nlf_lab" style="margin-bottom: 0.0417rem">
              <input type="text" style="width: 86%" password v-model="form.password" v-on:keyup.enter="denglu"
                class="nlf_inp nlf_pwd" placeholder="密码" />
              <p @click="SwitchPassDis()" style="
                  display: inline-block;
                  width: 0.125rem;
                  height: 0.125rem;
                  cursor: pointer;
                ">
                <img src="../../static/images/mm.png" alt="" />
              </p>
            </div>
            <div style="width: 90%; margin: 0 auto 0.2083rem">
              <p style="display: inline-block">
                <img style="
                    width: 0.125rem;
                    height: 0.125rem;
                    vertical-align: bottom;
                  " :src="messer" alt="" />
                <span id="sop" style="color: red; font-size: 0.0781rem"></span>
              </p>
              <span style="
                  cursor: pointer;
                  float: right;
                  font-size: 0.0781rem;
                  font-weight: 400;
                  color: #888888;
                ">忘记密码</span>
            </div>
          </div>
          <div v-else>
            <div class="nlf_lab" style="margin-bottom: 0.1042rem">
              <input v-model="form.userName" value class="nlf_inp" placeholder="手机号" />
            </div>
            <div style="width: 90%; height: 0.2344rem; margin: 0 auto 0.0417rem">
              <div class="nlf_lab" style="
                  margin-bottom: 0.0417rem;
                  width: 50%;
                  display: inline-block;
                ">
                <input type="text" password v-model="form.password" v-on:keyup.enter="denglu" class="nlf_inp nlf_pwd"
                  placeholder="验证码" />
              </div>
              <Button style="
                  float: right;
                  width: 44%;
                  height: 100%;
                  font-size: 0.0938rem;
                  font-weight: 400;
                ">获取验证码</Button>
            </div>
            <div style="width: 90%; margin: 0 auto 0.2083rem">
              <p style="display: inline-block">
                <img style="
                    width: 0.125rem;
                    height: 0.125rem;
                    vertical-align: bottom;
                  " :src="messer" alt="" />
                <span id="sop1" style="color: red; font-size: 0.0781rem"></span>
              </p>
              <span style="
                  cursor: pointer;
                  float: right;
                  font-size: 0.0781rem;
                  font-weight: 400;
                  color: #888888;
                ">没收到短信</span>
            </div>
          </div>
          <div style="width: 90%; margin: 0 auto">
            <Button @click="denglusd()" style="
                width: 100%;
                background: #4ab83e;
                height: 0.2083rem;
                font-size: 0.0938rem;
                font-weight: 400;
              " type="success">登录</Button>
            <!-- <p style="
                text-align: center;
                font-weight: 400;
                color: #888888;
                font-size: 0.0781rem;
                margin-top: 0.1042rem;
                cursor: pointer;
              " @click="zhuce()">
              没有账户？<span style="color: #4ab83e; margin-left: 0.026rem">立即注册</span>
            </p> -->
          </div>
        </div>
        <div style="width: 34%; float: right">
          <div style="text-align: center">
            <p class="pwx" style="margin-bottom: 0.1563rem">其他登录方式</p>
            <div style="
                width: 100%;
                height: 1.5104rem;
                border-left: 1px solid #bbbbbb;
                padding-top: 0.1042rem;
              ">
              <div style="
                  width: 0.8333rem;
                  height: 0.8333rem;
                  border: 1px solid #000;
                  margin: 0 auto 0.1042rem;
                "></div>
              <div style="font-weight: 400; color: #333333; font-size: 0.0833rem">
                <p style="margin-bottom: 0.026rem">使用微信扫一扫</p>
                即可登录
              </div>
            </div>
          </div>
        </div>
        <button @click="del()" class="xsx">
          <img style="width: 100%; height: 100%" src="../../static/images/qx.png" alt="" />
        </button>
      </div>
      <div class="sldw" v-else>
        <div>
          <div style="text-align: center">
            <p class="pwx" @click="signin = true" style="
                margin-top: 0.1042rem;
                margin-bottom: 0.1563rem;
                color: #4ab83e;
              ">
              免费注册
              <span style="
                  width: 0.4063rem;
                  height: 0.0208rem;
                  background: #4ab83e;
                  border-radius: 0.0156rem;
                  display: block;
                  margin: 0 auto;
                "></span>
            </p>
          </div>
          <div>
            <div class="nlf_lab" style="margin-bottom: 0.1042rem; width: 84%">
              <input v-model="form.userName" value class="nlf_inp" placeholder="手机号/用户名" />
            </div>
            <div style="width: 84%; height: 0.2344rem; margin: 0 auto 0.1042rem">
              <div class="nlf_lab" style="
                  margin-bottom: 0.0417rem;
                  width: 50%;
                  display: inline-block;
                ">
                <input type="text" password v-model="form.password" v-on:keyup.enter="denglu" class="nlf_inp nlf_pwd"
                  placeholder="验证码" />
              </div>
              <Button style="
                  float: right;
                  width: 44%;
                  height: 100%;
                  font-size: 0.0938rem;
                  font-weight: 400;
                ">获取验证码</Button>
            </div>
            <div v-if="!switchPassDisFlag" class="nlf_lab" style="width: 84%">
              <input type="password" style="width: 91%" password v-model="form.password" v-on:keyup.enter="denglu"
                class="nlf_inp nlf_pwd" placeholder="密码" />
              <p @click="SwitchPassDis()" style="
                  display: inline-block;
                  width: 0.125rem;
                  height: 0.125rem;
                  cursor: pointer;
                ">
                <img src="../../static/images/bmm.png" alt="" />
              </p>
            </div>
            <div v-else class="nlf_lab" style="width: 84%">
              <input type="text" style="width: 91%" password v-model="form.password" v-on:keyup.enter="denglu"
                class="nlf_inp nlf_pwd" placeholder="密码" />
              <p @click="SwitchPassDis()" style="
                  display: inline-block;
                  width: 0.125rem;
                  height: 0.125rem;
                  cursor: pointer;
                ">
                <img src="../../static/images/mm.png" alt="" />
              </p>
            </div>
            <div style="
                width: 84%;
                margin: 0.0417rem auto 0.0521rem;
                height: 0.125rem;
              ">
              <p style="display: inline-block">
                <img style="
                    width: 0.125rem;
                    height: 0.125rem;
                    vertical-align: bottom;
                  " :src="messer" alt="" />
                <span id="sop2" style="color: red; font-size: 0.0781rem"></span>
              </p>
            </div>
          </div>
          <div style="width: 84%; margin: 0 auto">
            <Button @click="denglusd()" style="
                width: 100%;
                background: #4ab83e;
                height: 0.2083rem;
                font-size: 0.0938rem;
                font-weight: 400;
                margin-bottom: 0.1146rem;
              " type="success">注册</Button>
            <div>
              <Checkbox v-model="single" class="cbox" style="
                  display: inline-block;
                  font-weight: 400;
                  color: #888888;
                  font-size: 0.0729rem;
                ">
                我已阅读并同意
                <a class="link" target="_blank" style="color: #00aeec" @click="yinsi1()">《用户注册协议》</a>
                <a class="link" target="_blank" style="color: #00aeec" @click="yinsi()">《隐私政策》</a>
              </Checkbox>
              <p style="
                  text-align: center;
                  font-weight: 400;
                  color: #888888;
                  font-size: 0.0781rem;
                  float: right;
                  cursor: pointer;
                " @click="denglu()">
                已有账户？<span style="color: #4ab83e; margin-left: 0.026rem">立即登录</span>
              </p>
            </div>
          </div>
        </div>
        <button @click="del()" class="xsx">
          <img style="width: 100%; height: 100%" src="../../static/images/qx.png" alt="" />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import md5 from "js-md5";
import Qs from "qs";
import axios from "@/libs/api.request";
export default {
  data() {
    return {
      switchPassDisFlag: false, //密码显示与隐藏
      signin: true,
      modal1: false,
      form: {
        userName: "",
        password: "",
      },
      single: false,
      typeds: "",
      messer: "",
    };
  },
  props: ["typed", "messe"],
  mounted() {
    this.typeds = this.typed;
    this.messer = this.messe;
  },
  methods: {
    //密码显示与隐藏
    SwitchPassDis() {
      this.switchPassDisFlag = !this.switchPassDisFlag;
    },
    mima() {
      this.signin = true;
      this.messer = "../../static/images/xx.png";
      this.form.userName = "";
      this.form.password = "";
      document.getElementById("sop1").innerHTML = "";
    },
    duanxin() {
      this.signin = false;
      this.messer = "../../static/images/xx.png";
      this.form.userName = "";
      this.form.password = "";
      document.getElementById("sop").innerHTML = "";
    },
    //跳转到登录页面
    denglu() {
      this.messer = "../../static/images/xx.png";
      this.typeds = "login";
      this.form.userName = "";
      this.form.password = "";
    },
    zhuce() {
      this.typeds = "register";
      this.messer = "../../static/images/xx.png";
      this.form.userName = "";
      this.form.password = "";
    },
    del() {
      this.typeds = "register";
      this.modal1 = false;
      this.$emit("childFn", this.modal1); //通过childFn 将值传递给父页面
    },
    denglusd() {
      if (this.signin && this.typeds == "login") {
        if (this.form.userName === "" || this.form.userName === undefined) {
          this.messer = "../../static/images/jsy.png";
          document.getElementById("sop").innerHTML = "请输入账号";
          return;
        };
        if (this.form.password === "" || this.form.userName === undefined) {
          this.messer = "../../static/images/jsy.png";
          document.getElementById("sop").innerHTML = "请输入密码";
          return;
        };
      };
      if (this.typeds == "register") {
        if (
          !(this.form.userName.length >= 6 && this.form.userName.length < 16)
        ) {
          this.messer = "../../static/images/jsy.png";
          document.getElementById("sop2").innerHTML = "账号长度应大于6小于16";
          return false;
        };
        if (this.form.password.length < 6) {
          this.messer = "../../static/images/jsy.png";
          document.getElementById("sop2").innerHTML = "密码长度应大于6位";
          return false;
        };
        //alert(this.single);
        if (!this.single) {
          this.messer = "../../static/images/jsy.png";
          document.getElementById("sop2").innerHTML = "请勾选协议政策！";
          return;
        };
      };
      var userName = "";
      var password = "";
      this.messer = "../../static/images/xx.png";
      if (this.signin && this.typeds === "login") {
        document.getElementById("sop").innerHTML = "";
      } else if (!this.signin && this.typeds === "login") {
        document.getElementById("sop1").innerHTML = "";
      } else if (this.typeds === "register") {
        document.getElementById("sop2").innerHTML = "";
      };
      if (this.typeds === "login") {
        this.loginF();
      };
      if (this.typeds === "register") {
        this.registerF();
      };
    },
    //注册方法
    registerF() {
      var posturl = this.config.baseUrl.pro + "/User/RegisterUserS";
      this.form.user_Name = this.form.userName;
      this.form.secretkey = md5(this.form.password);
      axios
        .request({
          url: posturl,
          method: "POST",
          data: Qs.stringify(this.form),
          headers: {
            authToken: localStorage.getItem("authToken")
          }
        })
        .then((resp) => {
          if (resp.data.result.code == 200) {
            this.$Message.error("注册成功，请登录！");
            this.typeds = "login";
            // this.$router.push({
            //   name: "SignIn",
            //   query: {
            //     type: "login",
            //   },
            // });
          } else {
            //this.PagaIndex = 1;
            this.messer = "../../static/images/jsy.png";
            document.getElementById("sop2").innerHTML =
              resp.data.result.message;
            // this.$Message.success(resp.data.result.message);
          };
        })
        .catch((err) => {
          this.$Message.error("注册失败");
        });
    },
    //登录方法
    loginF() {
      var posturl = this.config.baseUrl.pro + "/login/apiLogin";
      var password = md5(this.form.password);
      var userName = this.form.userName.trim();
      let postdata = {
        User_Name: userName,
        Secretkey: password,
        rememberClient: true
      };
      //登录
      return axios
        .request({
          url: posturl,
          method: "post",
          changeOrigin: true, //允许跨域
          headers: {
            authToken: localStorage.getItem("authToken")
          },
          data: Qs.stringify(postdata)
        })
        .then((resp) => {
          console.log(resp);
          if (resp.status == 200) {
            var data = resp.data.result;
            if (data.success) {
              this.modal1 = false;
              this.$emit("childFn", this.modal1); //通过childFn 将值传递给父页面
              if (data.Data.user.LastSelectTQRange) {
                localStorage.setItem("LastSelectTQRange", data.Data.user.LastSelectTQRange);
              }
              localStorage.setItem("userid", data.data.user.id);
              localStorage.setItem("authToken", data.token);
              localStorage.setItem("account", data.data.user.user_Name);
              localStorage.setItem("realname", data.data.user.real_Name);
              localStorage.setItem("systype", data.data.sysType);
              this.systype = data.data.sysType;
              localStorage.setItem("sendurl", data.data.url);
              this.sendsystem = false;
              this.getConfig();
              // this.tiaozhuan();
              // alert(localStorage.getItem("sendurl"));
              //var sendurl = "/" + localStorage.getItem("sendurl");

              //window.location.href = sendurl;
            } else {
              // this.$Message.error("登录失败，用户名或密码错误");
              // this.$Modal.error({
              //     title: "提示",
              //     content: "登录失败，" + data.message,
              // });
              this.messer = "../../static/images/jsy.png";
              document.getElementById("sop").innerHTML = data.message;
            };
          };
        })
        .catch((err) => {
          console.log(err);
          return { code: -1, message: "登录失败", token: null, data: "" };
        });
    },
    getConfig() {
      var posturl = this.config.baseUrl.pro + "/Base_Config/apiGetConfigLoad";
      return axios
        .request({
          url: posturl,
          method: "POST",
          changeOrigin: true, //允许跨域
          headers: {
            "Content-Type": "application/x-www-form-urlenCoded",
            authToken: localStorage.getItem("authToken"),
            accept: "text/plain"
          }
        })
        .then((resp) => {
          if (resp.status === 200) {
            var data = resp.data.Result.Data;
            console.log(data);
            for (var i = 0; i < data.length; i++) {
              var item = data[i];
              localStorage.setItem(item.Code, item.Value);
              localStorage.removeItem("TeacherEnCode");
              localStorage.removeItem("TeacherEnCodes");
              localStorage.removeItem("StudentEnCode");
              localStorage.removeItem("StudentEnCodes");
            }
          } else {
            // localStorage.clear();
            localStorage.removeItem("authToken")
            localStorage.removeItem("realname")
            localStorage.removeItem("userid")
            localStorage.removeItem("headerImg")
            localStorage.removeItem("userName")
            localStorage.removeItem("account")
            //this.loginStatus();
          };
        })
        .catch((err) => {
          localStorage.removeItem("authToken")
          localStorage.removeItem("realname")
          localStorage.removeItem("userid")
          localStorage.removeItem("headerImg")
          localStorage.removeItem("userName")
          localStorage.removeItem("account")
          // localStorage.clear();
          //this.loginStatus();
          console.log(err);
          return { code: -1, message: "登录失败", token: null, data: "" };
        });
    },
    ///登录状态判断
    loginStatus() {
      var sendurl = localStorage.getItem("sendurl");
      var token = localStorage.getItem("authToken");
      if (
        sendurl !== null &&
        sendurl !== undefined &&
        sendurl !== "" &&
        token !== null &&
        token !== undefined &&
        token !== ""
      ) {
        this.sendsystem = false;
        this.realname = localStorage.getItem("realname");
        this.getConfig();
      } else {
        this.Cancellation();
      };
    },
    tiaozhuan() {
      this.$router.push({
        name: "home"
      });
    },
    //隐私政策
    yinsi() {
      let pathInfo = this.$router.resolve({
        path: "/agreement",
        query: {
          Id: "2023"
        }
      });
      window.open(pathInfo.href, "_blank");
      // this.$router.push({
      //   name: "agreement",
      // });
    },
    //用户注册协议
    yinsi1() {
      let pathInfo = this.$router.resolve({
        path: "/agreement",
        query: {
          Id: "2024"
        }
      });
      window.open(pathInfo.href, "_blank");
    }
  }
};
</script>

<style scoped>
.fidx {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgb(0, 0, 0, 0.7);
  z-index: 11111;
  width: 100vw;
  height: 108.5vw;
  top: -7vw;
}

.fidx .nlf_lab {
  width: 90%;
  height: 0.2344rem;
  margin: 0 auto;
  border-radius: 0.0208rem;
  border: 0.0078rem solid #bbbbbb;
}

.fidx .nlf_lab .nlf_inp {
  font-size: 0.0938rem;
  width: 87%;
  height: 100%;
  border: 0;
  font-weight: 400;
  margin-left: 0.0781rem;
}

.fidx .sldw {
  position: fixed;
  top: 200px;
  background: #fff;
  border-radius: 0.0417rem;
  width: 3.3698rem;
  left: 50%;
  margin-left: -1.5625rem;
  height: 2.1875rem;
}

.fidx .pwx {
  display: inline-block;
  font-size: 0.1094rem;
  text-align: center;
  font-weight: bold;
  color: #333333;
  margin: 0.1979rem 0 0.2188rem;
  cursor: pointer;
}

.pwxactive {
  color: #4ab83e !important;
}

.fidx .xsx {
  position: absolute;
  font-size: 0.1094rem;
  top: 0;
  left: 3.151rem;
  border: 0px;
  background: #fff;
  width: 0.1823rem;
  height: 0.1823rem;
}
</style>



// WEBPACK FOOTER //
// src/components/gotlogin.vue